import { faCopy, faRefresh, faThumbsDown, faThumbsUp } from '@fortawesome/pro-regular-svg-icons';

import ClickableIcon from 'lib/common/components/ClickableIcon';
import CopyToClipboardButton from 'lib/common/components/atoms/CopyToClipboardIcon';

import { useAIContext } from '../../../../Context';
import { IQResponseState } from '../../../constants/IQResponseState';

import styles from './iq-results-actions.module.scss';

interface IQResultActionsProps {
  onThumbsUp?: () => void;
  onThumbsDown?: () => void;
  textToCopy?: string;
}

export default function IQResultActions({ onThumbsUp, onThumbsDown, textToCopy }: IQResultActionsProps) {
  const {
    state: { requestState },
    actions: { rethink },
  } = useAIContext();

  const isThinking = requestState === IQResponseState.RETHINKING;

  const DEFAULT_REWRITE_ACTIONS = [
    //TODO: thumb up and thumb down functionality to be created in a different ticket
    // {
    //   icon: faThumbsUp,
    //   onClick: onThumbsUp,
    // },
    // {
    //   icon: faThumbsDown,
    //   onClick: onThumbsDown,
    // },
    {
      icon: faRefresh,
      onClick: rethink,
      spin: isThinking,
    },
  ];

  return (
    <div className={styles['iq-results-actions']}>
      <CopyToClipboardButton text={textToCopy || ''} />
      {DEFAULT_REWRITE_ACTIONS.map((action) => (
        <ClickableIcon
          key={action.icon.iconName}
          icon={action.icon}
          spin={action.spin}
          disabled={isThinking}
          onClick={action.onClick}
          size={15}
        />
      ))}
    </div>
  );
}
